import * as reactUse from 'react-use'

const { useRafState, useMount } = reactUse

export function useScrollListener() {
    const [data, setData] = useRafState({
        x: 0,
        y: 0,
        lastX: 0,
        lastY: 0,
    })

    useMount(() => {
        const handleScroll = () => {
            setData((last) => {
                return {
                    x: window.scrollX,
                    y: window.scrollY,
                    lastX: last.x,
                    lastY: last.y,
                }
            })
        }

        window.addEventListener('scroll', handleScroll)

        return () => {
            window.removeEventListener('scroll', handleScroll)
        }
    })

    return data
}
